module.exports = __webpack_public_path__ + "static/media/diaticsLogo.0b051c2e.png";